<template>
  <div>
    <TsTypography as="h1"
                  variant="h2" appendClass="mb-6">{{
      useTranslation("forgotPassword", "Forgot Password")
    }}</TsTypography>

    <form
      @submit.prevent="handleFormSubmit"
      class="flex flex-col gap-y-4"
    >
      <div>
        <TsLabel :variant="authStore.forgot_password_error.email ? 'danger' : undefined"
        :message="emailErrorMessage">
          <TsInput
            v-model="authStore.forgot_password_item.email"
            :placeholder="emailPlaceholder"
            data-testid="forgot-passord-form-input"
            size="sm"
            @input="validateEmail"
          />
        </TsLabel>
      </div>

      <div>
        <TsButton
          :label="submitButtonLabel"
          type="submit"
          size="sm"
          :isLoading="authStore.is_forgot_password_button_loading"
          :disabled="authStore.is_forgot_password_button_loading"
          rounded
        />
      </div>

      <TsRow class="justify-between items-center ml-0">
        <TsTypography as="p" variant="sm" appendClass="text-sm"
          >
          <NuxtLinkWithLocale
            class="text-sm font-semibold underline hover:text-info dark:hover:text-info-dark cursor-pointer"
            to="/login"
          >
            {{ signInButtonLabel }}
          </NuxtLinkWithLocale>
        </TsTypography>
      </TsRow>

      <TsAlert
        v-if="authStore.error_message"
        variant="info"
        appendClass="mt-2 px-2 p-1.5"
      >
        <template #alert-msg>
          {{ useTranslation(authStore.error_message,'We hebben u een resetlink gestuurd.') }}</br>
          <div class="mt-4">{{ useTranslation('SignIn-passwordResetLink', 'Als er een account is dat overeenkomt met dit e-mailadres, sturen we u een link voor het opnieuw instellen van uw wachtwoord.') }}</div>
        </template>
      </TsAlert>

      <TsAlert
        v-if="authStore.success_message"
        variant="success"
        appendClass="mt-2 px-2 p-1.5"
      >
        <template #alert-msg>
          {{ authStore.success_message }}
        </template>
      </TsAlert>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

const route = useRoute();
const authStore = useAuthStore();
authStore.error_message = "";
authStore.success_message = "";
const emailPlaceholder = useTranslation("enterEmail", "Voer een e-mailadres in");
const signInButtonLabel = useTranslation("backToSignIn", "Terug naar inloggen");
const submitButtonLabel = useTranslation("submit", "Indienen");

onMounted(() => {
  const email = route.query.email || "";
  authStore.forgot_password_error.email = "",
  authStore.forgot_password_item.email = String(email);
  formViewLogger("forgot_password");
});

// GTM logger for form start

let formInteracted = false;

const handleInputStart = (formField:string) => {
  if (!formInteracted) {
    formInteracted = true;
    logEvent({
        options: {
          eventAction: "input",
          eventProperties: {
          form: {
            form_name: "forgot_password",
            form_field: formField
                }                
        },
          eventInteraction: true,
          eventLabel: `User started filling sign-up form`,
          eventName: "form_start",
        },
      });
  }
};
const validateEmail = () => {
  handleInputStart("email");
  const email = authStore.forgot_password_item.email;

  if (!email) {
    authStore.forgot_password_error.email = useTranslation("emailRequired", "E-mail is vereist.");
  } else if (!validateEmailFormat(email)) {
    authStore.forgot_password_error.email = useTranslation("emailValidation", "E-mail moet geldig zijn.");;
  } else {
    authStore.forgot_password_error.email = "";
  }
};

const validateEmailFormat = (email: string) => {
  if (typeof email !== "string") {
    return false;
  }
  const emailPattern = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};

const emailErrorMessage = computed(() => {
  return authStore.forgot_password_error.email
    ? authStore.forgot_password_error.email
    : "";
});

const handleFormSubmit = () => {
  validateEmail();
  if (authStore.forgot_password_error.email) {
    return;
  }
  authStore.sendForgotPasswordMail()
  // GTM logger for form-submit

  const userData = {
    event: 'form_submit',
    form: {
      form_name: 'reset-passwrod-form',
      form_data: {
        title: authStore.sign_up_form.title,
        first_name: authStore.sign_up_form.first_name,
        last_name: authStore.sign_up_form.last_name,
        email: authStore.forgot_password_item.email,
      }
    }
  }

  logEvent({
    options: {
      eventAction: "form_submit",
      eventProperties: userData,
      eventInteraction: true,
      eventLabel: `User submitted the forgot password form`,
      eventName: "form_submit",
    },
  });
};
</script>
